var collectionHeader = document.querySelector(".collection-wrapper.page-header");
var showDescription = function () {
  this.classList.toggle("active");
  var collectionDescription = this.children[1];
  if (collectionDescription.style.maxHeight) {
    collectionDescription.style.maxHeight = null;
  } else {
    collectionDescription.style.maxHeight = collectionDescription.scrollHeight + "px";
  }
}
enquire.register("screen and (max-width: 1024px)", {
  match: function() {
    collectionHeader.addEventListener("click", showDescription);
  },
  unmatch: function() {
    collectionHeader.removeEventListener("click", showDescription);
  }
});
